module.exports = __webpack_public_path__ + "a2390c461595b860c97d54977f95eddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/jiaotong_c.png
// module id = 250
// module chunks = 3